import RequestStatus from '../model/RequestStatus';
import SearchType, { ProductMatchPageResponse } from '../model/ProductMatch';

export const GENERAL_PRODUCT_DATA_QUERY_START =
  'GENERAL_PRODUCT_DATA_QUERY_START';
export const GENERAL_PRODUCT_DATA_QUERY_SUCCESS =
  'GENERAL_PRODUCT_DATA_QUERY_SUCCESS';
export const GENERAL_PRODUCT_DATA_QUERY_FAILED =
  'GENERAL_PRODUCT_DATA_QUERY_FAILED';

export interface GeneralProductDataQueryStartAction {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly countryCode: string;
  readonly searchKey: string;
  readonly searchType: SearchType;
  readonly pageOffset: number;
}

export const setGeneralProductDataQueryStart = (
  countryCode: string,
  searchKey: string,
  pageOffset: number,
): GeneralProductDataQueryStartAction => ({
  type: GENERAL_PRODUCT_DATA_QUERY_START,
  requestStatus: RequestStatus.LOADING,
  countryCode,
  searchKey,
  searchType: SearchType.GENERAL,
  pageOffset,
});

export interface GetGeneralProductDataQueryComplete {
  readonly type: string;
  readonly requestStatus: RequestStatus;
  readonly productData: any;
}

export const getGeneralProductDataQuerySuccessAction = (
  response: ProductMatchPageResponse,
): GetGeneralProductDataQueryComplete => ({
  type: GENERAL_PRODUCT_DATA_QUERY_SUCCESS,
  requestStatus: RequestStatus.SUCCESS,
  productData: response,
});

export const getGeneralProductDataQueryFailedAction =
  (): GetGeneralProductDataQueryComplete => ({
    type: GENERAL_PRODUCT_DATA_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    productData: null,
  });
